module.exports = __webpack_public_path__ + "static/media/yampi5.2e5c7b9c.png";